export const environment = {
  type: 'dev',
  production: false,
  staticUrl: 'https://static.deamicis.cloud',
  authUrl: 'https://dev-auth.deamicis.cloud',
  apiUrl: 'https://dev-api.deamicis.cloud',
};
